import plpService from 'Services/plpService'
import SearchInput from 'Components/SearchInput/SearchInput'
import { plpType } from 'Models/plpType'
import { HorizontalLoader, ModalWrapper, Pagination } from 'Components'
import { TimeConverter } from 'Helpers/TimeConverter'
import { useState, useEffect, Key, FC } from 'react'
import { Link } from 'react-router-dom'
import { checkSearchInputType } from 'Helpers'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { LeaseAssetsType } from '@/Models'
import Swal from 'sweetalert2'

const LeaseAssetTradersCard: FC<{ assets?: LeaseAssetsType[] }> = ({ assets }) => {
  const [plp, setPlp] = useState<plpType[]>([])

  const [loading, setLoading] = useState(false)

  const [pageNumber, setPageNumber] = useState(1)

  const [sortOrder, setSortOrder] = useState('DESC')

  const [status, setStatus] = useState('ALL')

  const [searching, setSearching] = useState(false)

  const [searchReturnResult, setSearchReturnResult] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getPlp = async () => {
    setLoading(true)
    await plpService.index(pageNumber, sortOrder, status, undefined, 'V2').then(
      (response) => {
        setLoading(false)
        setPlp(response?.data.data.dataset)
        console.log('Traders Card response', response)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: object }) => {
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getPlp()
  }, [pageNumber, sortOrder, status])

  const handleSearch = async (searchTermRaw: string) => {
    // If a search operation is already in progress, return early
    if (searching) {
      // return;
    }

    // Set the searching flag to true to indicate that a search is starting
    setSearching(true)
    setSearchReturnResult(false)

    const searchTerm = searchTermRaw.trim()

    // Perform search operation using the searchTerm
    console.log('Searching for:', searchTerm)

    // Perform search operation using the searchTerm
    const searchTermRes = checkSearchInputType(searchTerm)

    let endpoint = ''
    if (searchTermRes === 'PhoneNumber') {
      endpoint = `customerMsisdn=${encodeURIComponent(searchTerm)}`
    } else if (searchTermRes === 'AlphaNumeric') {
      endpoint = `customerAccountId=${encodeURIComponent(searchTerm)}`
    } else if (searchTermRes === 'Numeric') {
      endpoint = `customerUserId=${encodeURIComponent(searchTerm)}`
    } else if (searchTermRes === 'name') {
      endpoint = `customerFirstName=${encodeURIComponent(searchTerm)}`
    }

    if (endpoint === '') {
      setLoading(false)
      setSearching(false)
      getPlp()
      return
    }

    setLoading(true)
  }

  const searchRequest = async (data: {
    firstName: string | undefined
    lastName: string | undefined
  }) => {
    console.log(data)
  }

  const cancelSearch = () => {
    getPlp()
  }

  const [aprovalReq, setAprovalReq] = useState(false)

  const { showAlert } = ShowTGAlert()

  const [searchOptionRequest, setSearchOptionRequest] = useState(false)

  const [reasonModal, setReasonModal] = useState(false)
  const [ID, setID] = useState<string>()
  const toggleReasonModal = () => setReasonModal(!reasonModal)

  const toggleSuspension = async (referenceId: string) => {
    setID(referenceId)
    setAprovalReq(true)
    await plpService.toggleSuspension(referenceId).then(
      (response) => {
        console.log('getPlpDetails', response)
        setAprovalReq(false)
        showAlert({
          message: 'Traders Card status saved successfully',
          show: true,
          title: 'Success',
          type: 'success',
        })

        setTimeout(() => {
          getPlp()
        }, 2000)
      },
      (error: { response: { data: { error: string } } }) => {
        setAprovalReq(false)
        console.log('getPlpDetails error', error.response)
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })
      },
    )
  }

  const [showModal, setShowModal] = useState(false)
  const [assigningRequest, setAssigningRequest] = useState(false)

  const [selectedPLPID, setselectedPLPID] = useState('')
  const [selectedAssetID, setselectedAaaetID] = useState('')

  const asignToStation = (id: string) => {
    setselectedPLPID(id)
    setShowModal(true)
  }

  const submitAssignToStation = async (e: { preventDefault: () => void }) => {
    e.preventDefault()

    setAssigningRequest(true)

    await plpService.assignStation(selectedPLPID, selectedAssetID).then(
      () => {
        setAssigningRequest(false)
        setShowModal(false)
        showAlert({
          message: 'Traders Card added to station lease asset successfully',
          show: true,
          title: 'Success',
          type: 'success',
        })
      },
      (error: { response: { data: { error: string } } }) => {
        setAssigningRequest(false)
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })
      },
    )
  }

  const unasignToStation = async (id: string) => {
    setAprovalReq(true)
    await plpService.unassignStation(id).then(
      () => {
        setAprovalReq(false)
        showAlert({
          message: 'Traders Card removed from station lease asset successfully',
          show: true,
          title: 'Success',
          type: 'success',
        })
      },
      (error: { response: { data: { error: string } } }) => {
        setAprovalReq(false)
        console.log('getPlpDetails error', error.response)
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })
      },
    )
  }

  const exportPLP = async (docType: string) => {
    const a = document.createElement('a')
    a.style.display = 'none'
    document.body.appendChild(a)

    Swal.fire({
      text: 'Exporting, please wait a moment.',
      timer: 2000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await plpService.exportPLP(sortOrder, status).then(
      (response) => {
        const streamedData = new Blob([response.data], { type: docType })
        const streamedUrl = window.URL.createObjectURL(streamedData)

        a.href = streamedUrl
        a.download = 'traders_card.' + (docType === 'text/csv' ? 'csv' : 'doc')
        a.click()
        window.URL.revokeObjectURL(streamedUrl)
        Swal.close()
      },
      (error) => {
        Swal.close()
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  return (
    <div className='card border-0'>
      <div className='card-header border-0 px-0'>
        <div className='row mt-2'>
          <div className='col-12 col-md-8'>
            <SearchInput
              onSearch={handleSearch}
              placeholder={'Search by MSISDN and Name'}
              searchRequest={searchRequest}
              searchOptionRequest={searchOptionRequest}
              searchReturnResult={searchReturnResult}
              cancelSearch={cancelSearch}
            ></SearchInput>
          </div>
          <div className='col-6 col-md-2 dropdown'>
            <button
              className='btn btn-filter dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
            >
              <svg
                width='17'
                height='17'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M10.94 22.65C10.46 22.65 9.99002 22.53 9.55002 22.29C8.67002 21.8 8.14002 20.91 8.14002 19.91V14.61C8.14002 14.11 7.81002 13.36 7.50002 12.98L3.76002 9.02001C3.13002 8.39001 2.65002 7.31001 2.65002 6.50001V4.20001C2.65002 2.60001 3.86002 1.35001 5.40002 1.35001H18.6C20.12 1.35001 21.35 2.58001 21.35 4.10001V6.30001C21.35 7.35001 20.72 8.54001 20.13 9.13001L15.8 12.96C15.38 13.31 15.05 14.08 15.05 14.7V19C15.05 19.89 14.49 20.92 13.79 21.34L12.41 22.23C11.96 22.51 11.45 22.65 10.94 22.65ZM5.40002 2.85001C4.70002 2.85001 4.15002 3.44001 4.15002 4.20001V6.50001C4.15002 6.87001 4.45002 7.59001 4.83002 7.97001L8.64002 11.98C9.15002 12.61 9.65002 13.66 9.65002 14.6V19.9C9.65002 20.55 10.1 20.87 10.29 20.97C10.71 21.2 11.22 21.2 11.61 20.96L13 20.07C13.28 19.9 13.56 19.36 13.56 19V14.7C13.56 13.63 14.08 12.45 14.83 11.82L19.11 8.03001C19.45 7.69001 19.86 6.88001 19.86 6.29001V4.10001C19.86 3.41001 19.3 2.85001 18.61 2.85001H5.40002Z'
                  fill='#868484'
                />
                <path
                  d='M6.00004 10.75C5.86004 10.75 5.73004 10.71 5.60004 10.64C5.25004 10.42 5.14004 9.94999 5.36004 9.59999L10.29 1.69999C10.51 1.34999 10.97 1.23999 11.32 1.45999C11.67 1.67999 11.78 2.13999 11.56 2.48999L6.63004 10.39C6.49004 10.62 6.25004 10.75 6.00004 10.75Z'
                  fill='#868484'
                />
              </svg>
              Filters
            </button>
            <div className='dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown'>
              <div className='dropdown-item'>
                <form action=''>
                  <div className='form-group'>
                    <label htmlFor=''>Sort List</label>
                    <select
                      id=''
                      className='form-control'
                      onChange={(e) => {
                        setSortOrder(e.target.value)
                      }}
                    >
                      <option value='DESC'>Descending Order</option>
                      <option value='ASC'>Ascending Order</option>
                    </select>
                  </div>

                  <div className='form-group mt-3'>
                    <label htmlFor=''>Status</label>
                    <select
                      id=''
                      className='form-control'
                      onChange={(e) => {
                        setStatus(e.target.value)
                      }}
                    >
                      <option value='ALL'>All</option>
                      <option value='PENDING_APPROVAL'>Pending Approval</option>
                      <option value='APPROVED'>Approved</option>
                      <option value='REJECTED'>Rejected</option>
                    </select>
                  </div>
                  <div className='row mt-3'>
                    <div className='col-md-6'>
                      <button
                        type='button'
                        className='btn btn-reset'
                        onClick={() => {
                          setSortOrder('DESC')
                          setStatus('ALL')
                        }}
                      >
                        Reset
                      </button>
                    </div>
                    <div className='col-md-6 text-end'>
                      <button
                        type='button'
                        className='btn btn-filter'
                        onClick={() => setSortOrder('DESC')}
                      >
                        Filter
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className='col-6 col-md-2 dropdown'>
            <button
              className='btn btn-export dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
            >
              <svg
                width='17'
                height='17'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M9 11V17L11 15'
                  stroke='#868484'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M9 17L7 15'
                  stroke='#868484'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14'
                  stroke='#868484'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M22 10H18C15 10 14 9 14 6V2L22 10Z'
                  stroke='#868484'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>{' '}
              Export
            </button>

            <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
              <li className='dropdown-item' onClick={() => exportPLP('text/csv')}>
                Export as .csv
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className='card-body'>
        <div className='table-responsive'>
          <table className='table'>
            <thead>
              <tr>
                <td>Company Name</td>
                <td>User</td>
                <td>Phone Number</td>
                <td>Status</td>
                {/* <td>Active Status</td>
                <td>L.A Status</td> */}
                <td>Date Created</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {plp.length > 0 &&
                plp.map((data: plpType, index: Key) => (
                  <tr key={index}>
                    <td>#{data.companyName}</td>
                    <td>
                      {data.customer.firstName} {data.customer.lastName}
                    </td>
                    <td>{data.customer.msisdn}</td>
                    <td className='text-'>
                      {data.plpApplicationVerified === 'REJECTED' && (
                        <span className='status fw-bolder rejected'>
                          {data.plpApplicationVerified}
                        </span>
                      )}
                      {data.plpApplicationVerified === 'PENDING_APPROVAL' && (
                        <span className='status fw-bolder pending'>
                          {data.plpApplicationVerified}
                        </span>
                      )}
                      {data.plpApplicationVerified === 'APPROVED' && (
                        <span className='status fw-bolder approved'>
                          {data.plpApplicationVerified}
                        </span>
                      )}
                    </td>
                    {/* <td className='text-'>
                      {data.isSuspended === true ? (
                        <span className='status fw-bolder'>Suspended</span>
                      ) : (
                        <span className='active fw-bolder'>Active</span>
                      )}
                    </td>
                    <td>-</td> */}
                    <td>{TimeConverter(data.createdAtISO8601)}</td>
                    <td className='dropdown option-dropdown'>
                      <button
                        className='btn border-0 dropdown-toggle'
                        data-bs-toggle='dropdown'
                        aria-expanded='false'
                        data-bs-popper-config='{"strategy":"fixed"}'
                      >
                        <svg
                          width='18'
                          height='18'
                          viewBox='0 0 18 18'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                            fill='#707070'
                          />
                          <path
                            d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                            fill='#707070'
                          />
                          <path
                            d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                            fill='#707070'
                          />
                        </svg>
                      </button>

                      <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                        <Link to={`/traders-card/${data.id}`} className='text-decoration-none'>
                          <li className='dropdown-item'>View Details</li>
                        </Link>
                        <li className='dropdown-item'>
                          <Link to={''} onClick={() => asignToStation(data.id)}>
                            Assign to Station Lease Asset
                          </Link>
                        </li>
                        <li className='dropdown-item'>
                          <Link to={''} onClick={() => unasignToStation(data.id)}>
                            Unassign from Station Lease Asset
                          </Link>
                        </li>
                        <li className='dropdown-item'>
                          <Link to={''}>View asigned list</Link>
                        </li>
                        <li
                          className='dropdown-item text-danger'
                          onClick={() =>
                            confirm(
                              `Are you sure you want to ${data.isSuspended === true ? 'Unsuspend' : 'Suspend'} this TradersCard?`,
                            ) === true
                              ? toggleSuspension(data.id)
                              : false
                          }
                        >
                          {data.isSuspended === true ? 'Unsuspend' : 'Suspend'}
                        </li>
                      </ul>
                    </td>
                  </tr>
                ))}

              {loading === false && plp.length === 0 && (
                <tr>
                  <td colSpan={8} className='text-center'>
                    No Traders Card application found
                  </td>
                </tr>
              )}
              {loading === true && plp.length === 0 && (
                <tr>
                  <td colSpan={8} className='text-center'>
                    <HorizontalLoader></HorizontalLoader>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {paginationData.total >= paginationData.pageSize && (
          <div className='pagination w-100 d-flex justify-content-center'>
            {paginationData.total && (
              <Pagination
                className='pagination-bar ps-0'
                currentPage={Number(paginationData.pageNumber)}
                totalCount={paginationData.total}
                pageSize={paginationData.pageSize}
                onPageChange={(page: React.SetStateAction<number>) => setPageNumber(page)}
              />
            )}
          </div>
        )}
      </div>

      <ModalWrapper
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        title='Asign Traders Card to Lease Asset'
        hideHeader={false}
      >
        <form onSubmit={submitAssignToStation}>
          <div className='form-input'>
            <label htmlFor='asset'>Choose an asset to assign</label>
            <select
              id='asset'
              className='form-control mt-1'
              onChange={(e) => setselectedAaaetID(e.target.value)}
            >
              <option>select</option>
              {assets &&
                assets.map((asset, index: Key) => (
                  <option key={index} value={asset.id}>
                    {asset.displayName}
                  </option>
                ))}
            </select>
          </div>

          <div className='form-input mt-3'>
            <button className='btn btn-default w-100 py-2' type='submit'>
              Assign{' '}
              {assigningRequest && <span className='spinner-border spinner-border-sm'></span>}
            </button>
          </div>
        </form>
      </ModalWrapper>
    </div>
  )
}

export default LeaseAssetTradersCard
